module.exports = __webpack_public_path__ + "static/media/close-heavy.bb868f29.svg";